"use client";
import React, { useState, useRef, useEffect } from "react";
import WcTextField from "../WcTextfield/WcTextField";
import WcTag from "../WcTag/WcTag";
import { Box, TextFieldProps } from "@mui/material";

export type WcTagInputProps = TextFieldProps & {
  onDataChanged: any;
  inputData?: any[];
  maxHeight?: number | string;
};

export const WcTagInput = (props: WcTagInputProps) => {
  const { disabled, inputData, onDataChanged, label, size, maxHeight, placeholder, sx } = props;
  const [tags, SetTags] = useState(inputData ? inputData : []);
  const tagRef = useRef(null);

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      event.preventDefault();
      //@ts-ignore
      SetTags([...tags, tagRef.current.value]);
      //@ts-ignore
      tagRef.current.value = "";
    }
  };

  useEffect(() => {
    if (inputData && inputData.length > 0) {
      SetTags(inputData);
    }
  }, [inputData]);

  useEffect(() => {
    if (tags) {
      onDataChanged(tags);
    }
  }, [SetTags, tags]);

  const handleDelete = (value: any) => {
    const newtags = tags.filter((val) => val !== value);
    SetTags(newtags);
  };

  return (
    <WcTextField
      inputRef={tagRef}
      multiline
      sx={[{ maxHeight: maxHeight }, ...(Array.isArray(sx) ? sx : [sx])]}
      disabled={disabled}
      size={size}
      margin="none"
      variant="filled"
      label={label}
      onKeyDown={handleKeyDown}
      placeholder={tags.length < 3 ? placeholder : ""}
      InputProps={{
        startAdornment: (
          <Box sx={{ margin: "0 0.2rem 0 0", display: "flex" }}>
            {tags.map((data, index) => (
              <WcTag data={data} controlDisabled={disabled} handleDelete={handleDelete} key={index} />
            ))}
          </Box>
        ),
      }}
    />
  );
};

export default WcTagInput;
